module.exports = "<p>\n  textinput works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /azp/_work/1/s/src/app/bi-admin/textinput/textinput.component.html
// module id = ../../../../../src/app/bi-admin/textinput/textinput.component.html
// module chunks = main